module.exports = __webpack_public_path__ + "img/tag7.bc505803.png";